import { useState } from "react";
import { Bell, LogOut, Settings } from "lucide-react";
import Aays from "../assets/img/AaysLogo.png";
import LogoutConfirmModal from "../../components/modal/LogoutConfirmModal";
import { Link } from "react-router-dom";

const HeaderContent = () => {
  const fullName = localStorage.getItem("userName") || "";
  const [openDialog, setOpenDialog] = useState(false);

  const logout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  const getFirstLastName = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    return parts.length === 1 ? parts[0] : `${parts[0]} ${parts.at(-1)}`;
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <img src={Aays} alt="AAYS" style={{ width: "100px" }} />
      </div>

      <div className="flex items-center gap-4">
        <Bell className="w-4 h-4 cursor-pointer text-[#404040] " />
        <Link to={"/admin/control/userManagement"}>
          <Settings className="w-4 h-4 cursor-pointer text-[#404040] " />
        </Link>

        <div className="flex items-center gap-2">
          <span className="text-[12px] text-[#818181]">
            {getFirstLastName(fullName)}
          </span>

          <button
            type="button"
            onClick={() => setOpenDialog(true)}
            className="w-8 h-8 rounded-full bg-[#E12AFB] text-white flex items-center justify-center text-[11px]"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>

      <LogoutConfirmModal
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={logout}
      />
    </>
  );
};

export default HeaderContent;
